<div *ngIf="download">
  <a [routerLink]="'./'" (click)="downloadFile(download)">{{download.name}}</a>
  <a #downloadLink class="d-none" download></a>
</div>
